import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { actionAdminCreateDiscountCode } from "../../actions/adminDiscountCodeActions";
import "./PopBanner.css";
import PopBannerRender from "./PopBannerRender";
import { useDiscountPercent } from "../../hooks/useDiscountPercent";

export default function PopsBanner(props) {
  const location = useLocation().pathname;
  const dispatch = useDispatch();
  // ONLY POP IF ISPOP === NO
  const isPoped = localStorage.getItem("popDiscountAccepted");
  const nowInMiliseconds = new Date().getTime();
  const [exitPopOpen, setExitPopOpen] = useState(false);

  // PROPS COMING FROM "PopsComponent"
  const { pop, /*popPrice,*/ isDiscountValid, remainingTime, hasDiscount } =
    props;

  //REDUX STATE THAT HOLDS CART SKU ITEMS
  const addOrRemoveSkuItemInCart = useSelector(
    (state) => state.addOrRemoveSkuItemInCart,
  );
  const { cartSkuItems } = addOrRemoveSkuItemInCart;

  // DISCOUNT CODE
  const [discountCodeState, setDiscountCodeState] = useState("");

  // CHECK IF THERE IS AUTHENTICATED USER
  //REDUX STATE THAT HOLDS AUTHENTICATED USER INFO
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const authenticateUser = useSelector((state) => state.authenticateUser);
  const { authenticatedUser } = authenticateUser;
  useEffect(() => {
    if (
      authenticatedUser &&
      (pop.generateDiscountCode || pop.generateInstantDiscount)
    ) {
      setIsAuthenticated(true);
    }
  }, [authenticatedUser, pop]);

  // CHECK IF POP IS TIME RESTRICTED
  const [isValid, setIsValid] = useState(false);
  useEffect(() => {
    if (!pop.isTemporary) {
      setIsValid(true);
    } else if (pop.startDate) {
      // COMPARE DATES TO CHECK IF START/END DATE IS VALID
      if (
        nowInMiliseconds > Number(pop.startDateInMiliseconds) &&
        nowInMiliseconds < Number(pop.endDateInMiliseconds)
      ) {
        setIsValid(true);
      }
    } else {
      setIsValid(false);
    }
  }, [pop, nowInMiliseconds]);

  // CHECK LOCAL STORAGE TO DECIDE WHEATHER A POP MUST BE DISPLAYED OR NOT
  const [mustKeptClose, setMustKeptClose] = useState(false);
  useEffect(() => {
    const popDiscountAccepted = localStorage.getItem("popDiscountAccepted");
    if (popDiscountAccepted === "Yes") {
      setMustKeptClose(true);
    }
  }, []);

  // SET TIMER IF DISCOUNT OFFER IS TIME RESTRICTED
  const [offerRemainingTime, setOfferRemainingTime] = useState(0);
  useEffect(() => {
    if (pop.displayCountDownTimer) {
      const timestamp = JSON.parse(
        localStorage.getItem("popDiscountTimestamp"),
      );

      if (timestamp?.status === "valid") {
        const remainder = Number(timestamp.expiresAt) - nowInMiliseconds;
        if (remainder > 0) {
          setOfferRemainingTime(remainder);
          localStorage.setItem("offerRemainingTime", remainder);
          window.dispatchEvent(new Event("offerCountDownStarted"));
        } else if (timestamp) {
          localStorage.removeItem("popDiscountTimestamp");
          localStorage.removeItem("popsDiscount");
          localStorage.removeItem("popDiscountAccepted");
          localStorage.removeItem("offerRemainingTime");
        }
      }
    }
  }, [pop, nowInMiliseconds, exitPopOpen]);

  // FUNCTION TO IMPLEMENT "ClickOutsideToClose" FUNCTIONALITY
  const refPop = useRef(null);
  const handleClickOutsidePop = (event) => {
    if (refPop.current && !refPop.current.contains(event.target)) {
      if (pop.popType === "intentPop") {
        setIntentPopOpen(false);
      } else if (pop.popType === "exitPop") {
        setExitPopOpen(false);
      }

      // ONCE A POP IS CLOSED IT SHOULD STAY CLOSED OR SHOULD NOT
      if (pop.displayCountDownTimer && offerRemainingTime > 0) {
        localStorage.setItem("popDiscountAccepted", "No");
      } else if (
        (pop.generateDiscountCode || pop.generateInstantDiscount) &&
        !pop.displayCountDownTimer
      ) {
        localStorage.setItem("popDiscountAccepted", "Yes");
        setMustKeptClose(true);
      } else {
        localStorage.setItem("popDiscountAccepted", "No");
      }

      window.dispatchEvent(new Event("popDiscountRejected"));
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsidePop, false);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsidePop, false);
    };
  });
  // FUNCTION TO HANDLE CLOSE ICON
  function handleClosePops() {
    if (pop.popType === "intentPop") {
      setIntentPopOpen(false);
    } else if (pop.popType === "exitPop") {
      setExitPopOpen(false);
    }

    // ONCE A POP IS CLOSED IT SHOULD STAY CLOSED OR SHOULD NOT
    localStorage.setItem("popDiscountAccepted", "No");

    window.dispatchEvent(new Event("popDiscountRejected"));
  }

  // CALCULATE DISCOUNT AMOUNT
  const discountAmount = useDiscountPercent(
    pop.discountPercent,
    cartSkuItems?.[0]?.priceForOne,
  );

  function handleYesButton(amount) {
    localStorage.setItem("popsDiscount", amount);
    localStorage.setItem("popDiscountAccepted", "Yes");
    window.dispatchEvent(new Event("popsDiscountUpdated"));
    setExitPopOpen(false);
  }

  // EXIT POP LOGIC

  const onMouseUpdate = (e) => {
    // CHECK LOCAL STORAGE TO SEE IF CONTACT DETAILS SAVED
    const isLocal = localStorage.getItem("beddo");
    const isPoped = localStorage.getItem("popDiscountAccepted");
    const isExtraDiscountShown = localStorage.getItem("extraDiscount");

    /*    console.log({
     mustKeptClose: mustKeptClose,
      isPoped: isPoped,
      isActive: pop.isActive,
      popType: pop.popType === "exitPop",
      isValid: isValid,
      isAuthenticated: isAuthenticated,
      isDiscountValid: isDiscountValid,
      remainingTime: remainingTime <= 0,
      isExtraDiscountShown: isExtraDiscountShown,
      hasDiscount: hasDiscount,
      toElement: e.toElement,
      relatedTarget: e.relatedTarget,
      clientY: e.clientY < 10,  
      isLocal: isLocal,
    });
    */

    // ONLY RUN WHEN LOCATION MATCHES
    if (
      !isLocal &&
      pop.displayOnlyHere.find((free) => location.includes(free))
    ) {
      if (
        !e.toElement && // THESE SIGNAL THAT MOUSE IS OUT OF WINDOW
        !e.relatedTarget &&
        e.clientY < 10 && // THIS SIGNALS THAT CLIENT MOUSE GOES UPWARDS
        !mustKeptClose &&
        !isPoped &&
        pop.isActive &&
        pop.popType === "exitPop" &&
        isValid &&
        !isAuthenticated &&
        !isDiscountValid &&
        remainingTime <= 0 &&
        !isExtraDiscountShown &&
        !hasDiscount
      ) {
        if (pop.displayCountDownTimer) {
          const timestamp = JSON.parse(
            localStorage.getItem("popDiscountTimestamp"),
          );

          const discountExpiryPeriod =
            Number(pop.discountExpiry /* Minutes */) * 1000 * 60;

          if (!timestamp) {
            const obj = {
              status: "valid",
              startedAt: new Date().getTime(),
              expiresAt: new Date().getTime() + discountExpiryPeriod,
            };
            localStorage.setItem("popDiscountTimestamp", JSON.stringify(obj));
          }
        }

        // OPEN EXIT POP
        setExitPopOpen(true);

        if (!exitPopOpen && pop.generateDiscountCode) {
          // GET NOW IN MILISECONDS

          const year = new Date().getFullYear();
          const month = new Date().getMonth() + 1;
          const day = new Date().getDate();

          // CREATE DISCOUNT CODE
          const discountCode = `beddo${
            nowInMiliseconds.toString().slice(-3) +
            Math.floor(Math.random() * 9).toString()
          }`;

          // SAVE DISCOUNT CODE IN REACT STATE
          setDiscountCodeState(discountCode);

          // DISPATCH DISCOUNT CODE
          dispatch(
            actionAdminCreateDiscountCode({
              discountCode: discountCode,
              discountAmount,
              discountExpiryDate: `${year}-${month}-${day}`,
              discountExpiryInMiliseconds:
                nowInMiliseconds + Number(pop.discountExpiry) * 60000,
              useDiscountCodeXTimes: pop.useDiscountXtimes
                ? pop.useDiscountXtimes
                : "Kısıtlama yok",
              remainingDiscountCodeXTimes: pop.useDiscountXtimes
                ? pop.useDiscountXtimes
                : "Kısıtlama yok",
              discountType: "Temporary",
              isDuplicateAllowed: true,
            }),
          );
        }
      }
    }
  };
  useEffect(() => {
    setTimeout(() => {
      document.addEventListener("mouseout", onMouseUpdate, false);
    }, 5000);
    return () => document.removeEventListener("mouseout", onMouseUpdate, false);
  });

  // INTENT POP LOGIC
  const [intentPopOpen, setIntentPopOpen] = useState(false);
  const [countDown, setCountDown] = useState(pop.popTimer);
  const [runTimer, setRunTimer] = useState(true);

  useEffect(() => {
    let timerId;
    const isLocated = pop.displayOnlyHere.find((free) =>
      location.includes(free),
    );

    if (runTimer && countDown > 0 && pop.isActive && isLocated) {
      timerId = setInterval(() => {
        setCountDown((countDown) => countDown - 1);
      }, 1000);
    } else {
      clearInterval(timerId);
    }

    return () => clearInterval(timerId);
  }, [runTimer, countDown, pop, location]);

  useEffect(() => {
    // CHECK LOCAL STORAGE TO SEE IF CONTACT DETAILS SAVED
    const isLocal = localStorage.getItem("beddo");

    if (
      countDown <= 0 &&
      runTimer &&
      !mustKeptClose &&
      !isPoped &&
      pop.isActive &&
      pop.popType === "intentPop" &&
      isValid &&
      !isAuthenticated &&
      !isLocal
    ) {
      // RESET COUNTERS
      setRunTimer(false);
      setCountDown(0);

      // OPEN INTENT POP
      setIntentPopOpen(true);

      // IF POP IS DISCOUNTED SET LOCAL STORAGE THIS WAY IF NOT THAT WAY
      if (pop.generateDiscountCode || pop.generateInstantDiscount) {
        localStorage.setItem("popDiscountAccepted", "Yes");
      } else {
        localStorage.setItem("popDiscountAccepted", "No");
      }

      if (isValid && pop.generateDiscountCode) {
        // GET NOW IN MILISECONDS

        const year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;
        const day = new Date().getDate();

        // CREATE DISCOUNT CODE
        const discountCode = `beddo${
          nowInMiliseconds.toString().slice(-3) +
          Math.floor(Math.random() * 9).toString()
        }`;

        // SAVE DISCOUNT CODE IN REACT STATE
        setDiscountCodeState(discountCode);

        // CREATE A DISCOUNT CODE
        dispatch(
          actionAdminCreateDiscountCode({
            discountCode: discountCode,
            discountAmount,
            discountExpiryDate: `${year}-${month}-${day}`,
            discountExpiryInMiliseconds:
              nowInMiliseconds + Number(pop.discountExpiry) * 60000,
            useDiscountCodeXTimes: pop.useDiscountXtimes
              ? pop.useDiscountXtimes
              : "Kısıtlama yok",
            remainingDiscountCodeXTimes: pop.useDiscountXtimes
              ? pop.useDiscountXtimes
              : "Kısıtlama yok",
            discountType: "Temporary",
          }),
        );
      }
    }
  }, [
    countDown,
    runTimer,
    mustKeptClose,
    pop,
    dispatch,
    isValid,
    isAuthenticated,
    discountAmount,
    nowInMiliseconds,
    isPoped,
  ]);

  // CSS TRANSITION LOGIC FOR MODAL POP
  const [transition, setTransition] = useState(false);
  useEffect(() => {
    if (intentPopOpen) {
      setTimeout(() => {
        setTransition(true);
      }, 200);
    }
  }, [intentPopOpen]);

  return (
    <>
      {pop.isActive &&
        (pop.doNotDisplayHere.find((ban) => location.includes(ban))
          ? ""
          : pop.displayOnlyHere.find((free) => location.includes(free)) &&
            ((intentPopOpen && pop.popType === "intentPop") ||
              (exitPopOpen && pop.popType === "exitPop"))) &&
        (pop.displayCountDownTimer && offerRemainingTime > 0 ? (
          <PopBannerRender
            refPop={refPop}
            pop={pop}
            transition={transition}
            intentPopOpen={intentPopOpen}
            handleClosePops={handleClosePops}
            handleYesButton={handleYesButton}
            discountCodeState={discountCodeState}
            isDiscountValid={isDiscountValid}
            remainingTime={remainingTime}
            offerRemainingTime={offerRemainingTime}
            discountAmount={discountAmount}
            setExitPopOpen={setExitPopOpen}
          />
        ) : (
          !pop.displayCountDownTimer && (
            <PopBannerRender
              refPop={refPop}
              pop={pop}
              transition={transition}
              intentPopOpen={intentPopOpen}
              handleClosePops={handleClosePops}
              handleYesButton={handleYesButton}
              discountCodeState={discountCodeState}
              discountAmount={discountAmount}
              isDiscountValid={isDiscountValid}
              remainingTime={remainingTime}
              setExitPopOpen={setExitPopOpen}
            />
          )
        ))}
    </>
  );
}
